import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!

  return (!_ctx.isEmpty)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isText)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.is_component), _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
              main: _withCtx((option) => [
                _renderSlot(_ctx.$slots, "main", _normalizeProps(_guardReactiveProps(option)))
              ]),
              cell: _withCtx(({value}) => [
                _renderSlot(_ctx.$slots, "cell", { value: value })
              ]),
              _: 3
            }, 16))
          : (_openBlock(), _createBlock(_component_Text, { key: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.value), 1)
              ]),
              _: 1
            })),
        _withDirectives(_createElementVNode("span", { class: "absolute flex justify-center items-center w-10 right-0 top-0 bottom-0" }, _toDisplayString(_ctx.wrapperPost), 513), [
          [_vShow, _ctx.wrapperPost]
        ])
      ]))
    : _createCommentVNode("", true)
}